import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils/buildUrl";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { IDatatype } from "./datatypes.types";

const API = `${API_URL}/datatypes`;

export const getDatatypes = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null
) => {
    const url = buildUrl(API, { page, size, search, ...filter });
    const result = await axios.get<Page<IDatatype>>(url);
    return result.data;
};

export const getDatatypesUnpaginated = async () => {
    const result = await axios.get<IDatatype[]>(`${API}/all`);
    return result.data;
};

export const getDatatypeById = async (id: number) => {
    const result = await axios.get<IDatatype>(`${API}/${id}`);
    return result.data;
};
